import { RoyaltiesAccountState } from './state';
import { royaltiesInitialState } from './initial-state';
import { RoyaltiesAccountActions } from './action-creators';
import * as actions from './actions';
import Dinero from 'dinero.js';

export const royaltiesReducer = (
  state: RoyaltiesAccountState = royaltiesInitialState,
  action: RoyaltiesAccountActions
): RoyaltiesAccountState => {
  switch (action.type) {
    case actions.GET_ROYALTIES_ACCOUNT: {
      return {
        ...state,
        account: undefined,
      };
    }

    case actions.GET_ROYALTIES_ACCOUNT_SUCCESS: {
      return {
        ...state,
        account: action.royaltiesAccount,
      };
    }

    case actions.DELETE_ROYALTIES_ACCOUNT_SUCCESS: {
      return {
        ...state,
        account: undefined,
      };
    }

    case actions.REGISTER_ROYALTIES_ACCOUNT_SUCCESS: {
      return {
        ...state,
        account: action.royaltiesAccount,
      };
    }

    case actions.LIST_PAYOUTS: {
      return {
        ...state,
        payouts: [],
        paid: Dinero({ amount: 0, precision: 2, currency: 'USD' }),
      };
    }

    case actions.LIST_PAYOUTS_SUCCESS: {
      return {
        ...state,
        payouts: action.payouts,
        paid: action.payouts.reduce((memo, payout) => {
          return memo.add(Dinero(payout.amount.value));
        }, Dinero({ amount: 0, precision: 2, currency: 'USD' })),
      };
    }

    case actions.GET_BALANCE_SUCCESS: {
      if (!action.accountId) {
        return {
          ...state,
          balance: action.balance,
        };
      }
      return {
        ...state,
        artists: {
          ...state.artists,
          [action.accountId]: {
            ...state.artists[action.accountId],
            balance: action.balance,
          }
        }
      }
    }

    case actions.GET_STATEMENTS_SUCCESS: {
      if (!action.accountId) {
        return {
          ...state,
          statements: action.statements,
        };
      }
      return {
        ...state,
        artists: {
          ...state.artists,
          [action.accountId]: {
            ...state.artists[action.accountId],
            statements: action.statements,
          }
        }
      };
    }

    default: {
      return { ...state };
    }
  }
};
